<template>
    <div class="mr-3 mb-2 mt-2">
        <div class="card-container">
            <div class="box-icon">
                <div class="card-icon">
                    <i :style="{ fontSize: '2.5rem' }" :class="icon"></i>
                </div>
            </div>
            <div class="card-dash">
                <div class="card-row">
                    <div class="card-info">
                        <div class="titulo">{{ title }}</div>
                        <h2 class="valor">{{ value }}</h2>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: "CardIndicador",
    props: ["icon", "title", "value"],
};
</script>

<style>

.card-container {
    display: flex;
    flex-direction: row;
}

.card-dash {
    width: 100%;
    height: 100px;
    background-color: #ffb300;
    border-radius: 0px 5px 5px 0px;
    box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
    padding: 17px;
    padding-top: 0px;
    display: flex;
    flex-direction: row;
    justify-content: flex-start;

}

.titulo {
    font-size: 14px;
    font-family: 'Roboto', sans-serif;
    color: #333333;
    margin-bottom: 5px;
    /* overflow: hidden; */
  
}

.valor {
    color: #333333;
}

.card-info {
    display: flex;
    flex-direction: column;
    padding-top: 15px;
    justify-content: start;
    align-items: start;
    text-align: start;
}

.card-icon {
    margin-top: 10px;
    margin-bottom: 10px;
    color: #ffffff;
}

.card-row {
    display: flex;
    flex-direction: row;
    justify-content: space-between;
}

.box-icon {
    width: 40%;
    background-color: #333333;
    border-radius: 5px 0px 0px 5px;
    box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
    display: flex;
    justify-content: center;
    align-items: center;
}

@media (max-width: 1340px) {
    .titulo {
        font-size: 12px;
    }
    .valor {
        font-size: 20px;
    }
}

</style>